import { connect } from 'react-redux';
import Page from './Page';
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Page);
